import { useGameStore, LEVEL_CONFIGS } from '../store/useGameStore';
import './LevelSelector.css';

export function LevelSelector() {
    const { level, setLevel } = useGameStore();

    return (
        <div className="level-selector">
            <span className="level-label">机巧盘等级</span>
            <div className="level-buttons">
                {LEVEL_CONFIGS.map((cfg) => (
                    <button
                        key={cfg.level}
                        className={`level-btn ${level === cfg.level ? 'active' : ''}`}
                        onClick={() => setLevel(cfg.level)}
                        title={`等级 ${cfg.level}: ${cfg.totalCells} 格`}
                    >
                        {cfg.level}
                    </button>
                ))}
            </div>
            <span className="level-cells">{LEVEL_CONFIGS[level - 1]?.totalCells ?? 0} 格</span>
        </div>
    );
}